import type { Contract } from '../api/generated/types.gen';
import { tenths, toTenths } from '../format';
import { sideName } from '../market';
import { bandIssue, type BuyBand } from './buyBand';
import type { Side } from './Ticket';

/** The phone's side buttons. With One-click on (plan 040) a tap buys at once; otherwise it opens the order sheet. */
export function PhoneBar({ contract, onOpen, buys, band }: { contract: Contract | null; onOpen: (s: Side) => void; buys: boolean; band: BuyBand | null }) {
  const verb = buys ? 'Buy ' : '';
  return <div className={`phone-bar${buys ? ' buys' : ''}`} data-testid="phone-bar">
    {(['yes', 'no'] as const).map(s => {
      const ask = toTenths(s === 'yes' ? contract?.yes_ask : contract?.no_ask);
      // Plan 046: a side priced outside your buy range can't be tapped.
      const outside = bandIssue(band, ask, ask);
      return <button key={s} className={s} disabled={!contract || !!outside} title={outside ?? undefined} onClick={() => onOpen(s)}>
        {verb}{sideName(s, contract?.ticker)} {tenths(ask)}</button>;
    })}
  </div>;
}

export type PhoneTab = 'desk' | 'positions' | 'orders';
/** Phone navigation between the desk and the dock's positions and orders. */
export function PhoneNav({ tab, onTab, positions, orders }: { tab: PhoneTab; onTab: (t: PhoneTab) => void; positions: number; orders: number }) {
  return <nav className="phone-nav" aria-label="Sections">
    {([['desk', 'Desk', 0], ['positions', 'Positions', positions], ['orders', 'Orders', orders]] as const).map(([id, label, n]) =>
      <button key={id} aria-pressed={tab === id} onClick={() => onTab(id)}>{label}{n ? <span className="count">{n}</span> : null}</button>)}
  </nav>;
}
